module.exports = __webpack_public_path__ + "img/hiw_img01.be13f787.png";